export default __webpack_public_path__ + "static/media/KG.e0daf143.svg";